module.exports = __webpack_public_path__ + "static/media/datu5.716964a2.png";